import {
  SUBSCRIPTION_REQUEST,
  SUBSCRIPTION_ERROR,
  SUBSCRIPTION_FETCH_SUCCESS,
  SUBSCRIPTION_FORM_SUCCESS,
  SUBSCRIPTION_CHANGE
} from '../constants/ActionTypes';

const blank = { isLoading: false, error: false, form_success: false };
const loading = { isLoading: true, error: false, form_success: false };
const error = { isLoading: false, error: true, form_success: false };
const success = { isLoading: false, error: false, form_success: true };

export const subscriptionSettings = (
  state = {
    isLoading: false,
    subscription_type: 'TrendsCompanyMailer',
    id: '',
    interval: 'disabled',
    day_of_week: undefined,
    send_at: undefined,
  },
  action
) => {
  switch (action.type) {
    case SUBSCRIPTION_REQUEST: {
      return Object.assign({}, state, loading);
    }
    case SUBSCRIPTION_ERROR: {
      return Object.assign({}, state, error);
    }
    case SUBSCRIPTION_FETCH_SUCCESS: {
      return Object.assign({}, state, blank, action.subscription);
    }
    case SUBSCRIPTION_FORM_SUCCESS: {
      return Object.assign({}, state, success, action.subscription);
    }
    case SUBSCRIPTION_CHANGE: {
      return Object.assign({}, state, action, blank);
    }
    default: {
      return state;
    }
  }
};
